import { useState } from 'react';

interface PlayerPanelProps {
  cover: string;
  title: string;
}

export default function PlayerPanel({ cover, title }: PlayerPanelProps) {
  const [showNotice, setShowNotice] = useState(false);

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-foreground-950">
      <img src={cover} alt={`${title} 播放示意图`} title={title} className="w-full h-full object-cover object-top opacity-60" />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
        <button
          onClick={() => setShowNotice(true)}
          aria-label="播放"
          className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-50/90 hover:bg-background-50 flex items-center justify-center cursor-pointer transition-transform hover:scale-105"
        >
          <i className="ri-play-fill text-3xl md:text-4xl text-primary-600"></i>
        </button>
        <span className="text-background-50 text-xs md:text-sm bg-foreground-950/60 px-3 py-1 rounded-full">
          界面演示 · 非真实播放
        </span>
      </div>

      {showNotice && (
        <div className="absolute inset-0 bg-foreground-950/80 flex items-center justify-center p-6 z-10">
          <div className="bg-background-50 rounded-lg p-5 max-w-sm w-full text-center">
            <i className="ri-information-line text-3xl text-accent-500 mb-2"></i>
            <p className="text-sm text-foreground-700">
              本区域仅为播放界面演示，菠萝蜜网不提供真实影视播放服务，感谢您的理解。
            </p>
            <button
              onClick={() => setShowNotice(false)}
              className="mt-4 px-5 py-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm cursor-pointer whitespace-nowrap"
            >
              我知道了
            </button>
          </div>
        </div>
      )}
    </div>
  );
}